import {InjectionToken} from '@angular/core';
import {CommonsConfig} from './commons/commons.config';
import {ApiConfig} from './api/api-config';
import {I18NConfig} from './i18n/i18n.service';
import {environment} from 'src/environments/environment';

export class AppConfig {
    commons: CommonsConfig;
    api: ApiConfig;
    i18n: I18NConfig;
    toasterTimeout: number;
    rootPath: string;
    domainPrefix?: string;
}

export const APP_CONFIG_TOKEN = new InjectionToken<AppConfig>('app.config');

export const APP_CONFIG: AppConfig = {
    commons: {name: 'Onboarding app', version: '0.0.0'},
    api: {},
    i18n: {},
    toasterTimeout: 2000,
    rootPath: environment.rootPath,
    domainPrefix: environment.domainPrefix,
};
